import { useState, useEffect, useCallback } from 'react';
import api from '../../api';
import Layout from '../../components/Layout';
import stili from '../../components/competenze/stili';
import ConflittoVersione, { eConflitto } from '../../components/ConflittoVersione';

// Elenchi modificabili dall'admin (oggi: Tipo F24). Aggiungere, rinominare, disattivare.
// Le righe già scritte conservano il testo che avevano: rinominare un valore non le cambia.
const ELENCO = 'tipo_f24';

export default function ElenchiValori() {
  const [valori, setValori] = useState([]);
  const [testi, setTesti] = useState({});
  const [nuovo, setNuovo] = useState('');
  const [errore, setErrore] = useState('');
  const [messaggio, setMessaggio] = useState('');
  const [conflitto, setConflitto] = useState(null);

  const carica = useCallback(() => {
    api.get(`/competenze/elenchi/${ELENCO}`, { params: { tutti: 1 } }).then(r => {
      setValori(r.data);
      setTesti(Object.fromEntries(r.data.map(v => [v.id, v.valore])));
    }).catch(err => setErrore(err.response?.data?.errore || 'Errore nel caricamento'));
  }, []);
  useEffect(() => { carica(); }, [carica]);

  const esito = (testo) => { setMessaggio(testo); setErrore(''); carica(); };
  const salva = async (v, cambi, version = v.version) => {
    setErrore('');
    setMessaggio('');
    try {
      await api.put(`/competenze/elenchi/${ELENCO}/${v.id}`, { ...cambi, version });
      setConflitto(null);
      esito('Salvato');
    } catch (err) {
      if (eConflitto(err)) setConflitto({ ...err.response.data, valore: v, cambi });
      else setErrore(err.response?.data?.errore || 'Salvataggio non riuscito');
    }
  };
  const aggiungi = async (e) => {
    e.preventDefault();
    setErrore('');
    setMessaggio('');
    try {
      await api.post(`/competenze/elenchi/${ELENCO}`, { valore: nuovo });
      setNuovo('');
      esito('Valore aggiunto');
    } catch (err) { setErrore(err.response?.data?.errore || 'Non è stato possibile aggiungere il valore'); }
  };

  return (
    <Layout>
      <div style={stili.topBar}><h2 style={{ margin: 0 }}>Elenchi · Tipo F24</h2></div>
      <p style={{ color: '#555', fontSize: '0.88rem', marginTop: 0 }}>
        Valori tra cui scegliere il <strong>Tipo F24</strong> nelle diciture come "Invio F24 – {'{tipo_f24}'}". Un valore disattivato non si può più scegliere, ma resta sulle righe già scritte.
        Rinominare un valore non cambia le righe già scritte.
      </p>
      {errore && <div style={stili.errore}>{errore}</div>}
      {messaggio && <div style={{ background: '#ecfdf5', color: '#166534', padding: '0.6rem', borderRadius: '6px', marginBottom: '0.8rem', fontSize: '0.88rem' }}>{messaggio}</div>}
      <table style={{ ...stili.table, maxWidth: '640px' }}>
        <thead><tr><th style={stili.th}>Valore</th><th style={stili.th}>Righe</th><th style={stili.th}>Stato</th><th style={stili.th}></th></tr></thead>
        <tbody>
          {valori.map(v => (
            <tr key={v.id} style={{ ...stili.tr, opacity: v.attivo ? 1 : 0.6 }}>
              <td style={stili.td}>
                <input value={testi[v.id] ?? ''} maxLength={100} onChange={e => setTesti(t => ({ ...t, [v.id]: e.target.value }))} aria-label={`Valore ${v.valore}`} style={stili.input} />
              </td>
              <td style={stili.td}>{v.usi}</td>
              <td style={stili.td}>{v.attivo ? 'Attivo' : 'Disattivato'}</td>
              <td style={{ ...stili.td, whiteSpace: 'nowrap' }}>
                <button onClick={() => salva(v, { valore: testi[v.id] })} disabled={testi[v.id] === v.valore} style={stili.btnSmall}>Rinomina</button>
                <button onClick={() => salva(v, { attivo: !v.attivo })} style={stili.btnSmall}>{v.attivo ? 'Disattiva' : 'Riattiva'}</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <form onSubmit={aggiungi} style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem', maxWidth: '640px' }}>
        <input value={nuovo} onChange={e => setNuovo(e.target.value)} maxLength={100} placeholder="Nuovo valore (es. Ritenute)" aria-label="Nuovo valore" style={stili.input} />
        <button type="submit" disabled={!nuovo.trim()} style={stili.btn}>Aggiungi</button>
      </form>
      {conflitto && (
        <ConflittoVersione conflitto={conflitto} onRicarica={() => { setConflitto(null); carica(); }} onSovrascrivi={() => salva(conflitto.valore, conflitto.cambi, conflitto.attuale.version)} />
      )}
    </Layout>
  );
}
